import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSideModalComponent from './adpSideModal.component';

let adpSideModalModule = angular.module('adpSideModal', [
  uiRouter
])

.component('adpSideModal', adpSideModalComponent)

.name;

export default adpSideModalModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSideModal/adpSideModal.js